import React, { useEffect, useRef, useState } from 'react';
import './PartnersForm.css';
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PhoneInput, getCountryCallingCode } from "react-international-phone";
import Heading from '../../../utls/Heading';

const PartnersForm = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        FName: "",
        LastName: "",
        Email: "",
        Company: "",
        Sales: "",
        Message: "",
        Number: "",
        Location: "",
    });

    const resetForm = () => {
        setFormData({
            FName: "",
            LastName: "",
            Email: "",
            Company: "",
            Sales: "",
            Message: "",
            Number: "",
            Location: "",
        });
    };

    const handlePhoneChange = (phone) => {
        setFormData((prev) => ({
            ...prev,
            Number: phone || "",
        }));
    };

    const validatePhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return false;

        // Remove all non-digit characters
        const cleanNumber = phoneNumber.replace(/\D/g, '');

        // Basic validation rules
        const validationRules = {
            minLength: 10,
            maxLength: 15,
            // Add country-specific rules if needed
            countryRules: {
                'gb': { exactLength: 11 },  // UK numbers are typically 11 digits
                'us': { exactLength: 10 },  // US numbers are 10 digits
                'in': { exactLength: 10 }   // Indian numbers are 10 digits
            }
        };

        // Basic length check
        if (cleanNumber.length < validationRules.minLength ||
            cleanNumber.length > validationRules.maxLength) {
            return false;
        }

        // Check for obviously invalid patterns
        if (/^0{5,}/.test(cleanNumber)) { // Check for too many leading zeros
            return false;
        }

        if (/(\d)\1{7,}/.test(cleanNumber)) { // Check for 8 or more repeated digits
            return false;
        }

        return true;
    };

    const validateForm = () => {
        const errors = [];

        // Required field validation
        if (!formData.FName.trim()) errors.push("First Name is required");
        if (!formData.LastName.trim()) errors.push("Last Name is required");
        if (!formData.Email.trim()) errors.push("Email is required");
        if (!formData.Company.trim()) errors.push("Company is required");
        if (!formData.Message.trim()) errors.push("Message is required");
        if (!formData.Number.trim()) errors.push("Phone Number is required");

        // Email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (formData.Email && !emailRegex.test(formData.Email)) {
            errors.push("Please Enter A Valid Email Address");
        }

        // Enhanced phone number validation
        if (formData.Number && !validatePhoneNumber(formData.Number)) {
            errors.push("Please Enter A Valid Phone Number");
        }

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate form before submission
        const validationErrors = validateForm();
        if (validationErrors.length > 0) {
            validationErrors.forEach(error => toast.error(error));
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(
                "https://blueberry-travel.com/api/APIUser/SubmitEnquiryBBT",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }
            );

            if (response.ok) {
                await response.json();
                toast.success("Enquiry Submitted. Our Team Will Contact You Shortly.");
                resetForm();
            } else {
                toast.error("Failed To Submit The Form. Please Try Again Later.");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("An error occurred while submitting the form.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <div className="partners-form  pt-xxl-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 d-flex justify-content-center align-items-center">
                            <Heading className='headings w-75'><span>EXCITED TO
                                EXPLORE NEW
                                TRAVEL HORIZONS
                                <span style={{ fontWeight: "bold" }}>? </span> </span><span className="text-dark partners-span-dark"> <br />
                                    LET’S CREATE MEMORABLE AND
                                    UNMATCHED TRAVEL
                                    EXPERIENCES TOGETHER

                                </span>

                            </Heading>
                        </div>

                        <div className="col-lg-6">
                            <form className="form-container partnerform-container" onSubmit={handleSubmit}>
                                <div className="partner-form-row">
                                    <div className="form-field">
                                        <input
                                            type="text"
                                            name="FName"
                                            placeholder='First Name'
                                            value={formData.FName}
                                            onChange={(e) =>
                                                setFormData({ ...formData, FName: e.target.value })
                                            }
                                            required
                                        />
                                        {/* <label htmlFor="firstName">First Name<span>*</span></label> */}
                                    </div>
                                    <div className="form-field">
                                        <input
                                            type="text"
                                            name="LastName"
                                            placeholder='Last Name'
                                            value={formData.LastName}
                                            onChange={(e) =>
                                                setFormData({ ...formData, LastName: e.target.value })
                                            }
                                            required
                                        />
                                        {/* <label htmlFor="lastName">Last Name<span>*</span></label> */}
                                    </div>
                                </div>
                                <div className="partner-form-row full-width">
                                    <div className="form-field">
                                        <input
                                            type="text"
                                            name="Company"
                                            placeholder='Company Name'
                                            value={formData.Company}
                                            onChange={(e) =>
                                                setFormData({ ...formData, Company: e.target.value })
                                            }
                                            required
                                        />
                                        {/* <label htmlFor="company">Company<span>*</span></label> */}
                                    </div>
                                </div>
                                <div className="partner-form-row">
                                    <div className="form-field">
                                        <PhoneInput
                                            country={"gb"}
                                            value={formData.Number}
                                            onChange={handlePhoneChange}
                                            inputClassName="form-control"
                                            containerClass="phone-input-container"
                                            className="partner-phone-container"
                                            inputProps={{
                                                name: "Number",
                                                required: true,
                                                placeholder: "Phone Number",
                                            }}
                                            enableSearch={true}
                                            preferredCountries={["gb", "us", "in"]}
                                            required
                                        />
                                        {/* <label htmlFor="mobileNumber" className='label2' >Mobile Number<span>*</span></label> */}
                                    </div>
                                    {/* <div className="form-field">
                                        <input
                                            type="text"
                                            name="Email"

                                            value={formData.Email}
                                            onChange={(e) =>
                                                setFormData({ ...formData, Email: e.target.value })
                                            }
                                            required
                                        />
                                        <label htmlFor="email" className='label3'>Work E-mail Address<span>*</span></label>
                                    </div> */}
                                </div>

                                <div className="partner-form-row">

                                    <div className="form-field">
                                        <input
                                            type="text"
                                            name="Email"
                                            placeholder='Email'
                                            value={formData.Email}
                                            onChange={(e) =>
                                                setFormData({ ...formData, Email: e.target.value })
                                            }
                                            required
                                        />
                                        {/* <label htmlFor="email" className='label3'>Work E-mail Address<span>*</span></label> */}
                                    </div>
                                </div>

                                <div className="partner-form-row full-width">
                                    <div className="form-field">
                                        <textarea
                                            name="Message"
                                            placeholder='Message'

                                            rows="5"
                                            value={formData.Message}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    Message: e.target.value,
                                                })
                                            }
                                            required
                                        ></textarea>
                                        {/* <label htmlFor="company" className='label4'>How can we help?<span>*</span></label> */}
                                    </div>
                                </div>
                                {/* <div className="terms-container d-flex justify-content-start align-items-start partner-form-row">
                                    <input type="checkbox" id="terms" className="checkbox-input mt-1" required />
                                    <p className='text-dark'>Agree to <Link to="/terms-and-conditions"><span>T&C</span></Link> of Blueberry Travel.</p>
                                </div> */}
                                <div className="carouselCaption consult-enquir-btn">
                                    {/* <button className="btn fs4 fw-bold bg-transparent text-black text-uppercase leeter">
                                           Enquire Now
                                       </button> */}
                                    <button className="btn fs4 fw-bold bg-transparent text-black text-uppercase leeter" type="submit" disabled={loading} >
                                        {loading ? 'Loading...' : 'SUBMIT'}
                                    </button>
                                </div>
                            </form>

                            <ToastContainer
                                position="top-center"
                                autoClose={3000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                style={{ zIndex: 9999999999 }}
                                toastStyle={{
                                    backgroundColor: "white",
                                    color: "black",
                                    fontSize: "16px",
                                    padding: "15px 25px",
                                    borderRadius: "8px",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                                    margin: "10px auto",
                                    textAlign: "center",
                                    width: "fit-content"
                                }}
                                limit={1}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default PartnersForm